import React from 'react';

import './app-error.css';

export type AppErrorLayoutMode = 'fullPage' | 'embedded';

interface AppErrorLayoutProps {
  mode?: AppErrorLayoutMode;
  children: React.ReactNode;
}

const AppErrorLayout: React.FC<AppErrorLayoutProps> = ({ mode = 'fullPage', children }) => {
  const layoutClass =
    mode === 'embedded' ? 'app-error-layout app-error-layout--embedded' : 'app-error-layout';

  return (
    <div className={layoutClass} role="alert">
      {children}
    </div>
  );
};

export default AppErrorLayout;
